import { fromJS } from 'immutable';

import { INIT_STORE } from '@shared/actionTypes';
import { failureAction, successAction } from '@utils/actions';
import orderFlowReducer from '@core/utils/orderFlowReducer';

import ModuleStateModel, {
  USER_CLOSED_NO_LOCATION_POINT_TOAST,
  MAX_PRODUCT_QUANTITY_TOOLTIP_CLOSED,
  MEASURENMENT_UNITS,
  ONLINE_PAYMENT_TOOLTIP_CLOSED,
  SECTIONS_LIST,
  TOTAL_SECTIONS,
  IS_FETCHING_SECTION_LIST,
  HAS_FETCHED_SECTION_LIST,
  GROCERIES_TAB_KEY,
  EXTENDED_MENU_SECTION,
  SECTIONS_COUNT,
  STOP_FETCHING_SECTIONS,
  SECTIONS_HEIGHTS,
  CAPACITY_CHECK,
  ONE_CLICK_PRODUCT_SELECTED,
  ALL_SECTIONS,
  IS_FETCHING_ALL_SECTIONS,
  SECTION_TAB_ID,
  DISTANCE_VENDOR_PICKUP,
  PREFERRED_DISHES,
  IS_FETCHING_PREFERRED_DISHES,
} from './model';

import * as actions from './actionTypes';

const getNonDuplicatedSections = (sections, oldSections) => {
  const nonDuplicated = [];
  sections.forEach(section => {
    const isExist = oldSections.find(s => s.id === section.id);
    if (!isExist) {
      nonDuplicated.push(section);
    }
  });

  return nonDuplicated;
};

function shopDetailsModuleReducer(state = ModuleStateModel, action) {
  switch (action.type) {
    case INIT_STORE:
      return ModuleStateModel.mergeDeep(state);

    case actions.CLOSE_NO_LOCATION_POINT_TOAST:
      return state.set(USER_CLOSED_NO_LOCATION_POINT_TOAST, true);

    case actions.CLOSE_MAX_PRODUCT_QUANTITY_TOOLTIP:
      return state.set(MAX_PRODUCT_QUANTITY_TOOLTIP_CLOSED, true);

    case successAction(actions.FETCH_MEASUREMENT_UNITS_LIST):
      return state.set(MEASURENMENT_UNITS, fromJS(action.payload.data));

    case successAction(actions.FETCH_CAPACITY_CHECK):
      return state.set(CAPACITY_CHECK, fromJS(action.payload));

    case actions.CLOSE_ONLINE_PAYMENT_TOOLTIP:
      return state.set(ONLINE_PAYMENT_TOOLTIP_CLOSED, true);

    case actions.FETCH_SECTIONS_LIST:
      return state.set(IS_FETCHING_SECTION_LIST, true);

    case successAction(actions.FETCH_SECTIONS_LIST): {
      const { sections, totalSections, count } = action.payload;

      const oldSectionCount = state.get(SECTIONS_COUNT) || 0;
      const newCount = count + oldSectionCount;
      const oldSection = state.get(SECTIONS_LIST) || [];
      const nonDuplicated = getNonDuplicatedSections(
        sections,
        oldSection.toJS(),
      );
      return state
        .set(TOTAL_SECTIONS, totalSections)
        .set(IS_FETCHING_SECTION_LIST, false)
        .set(HAS_FETCHED_SECTION_LIST, true)
        .set(SECTIONS_COUNT, newCount)
        .set(STOP_FETCHING_SECTIONS, !count)
        .update(SECTIONS_LIST, current =>
          current.concat(fromJS(nonDuplicated)),
        );
    }

    case failureAction(actions.FETCH_SECTIONS_LIST):
      return state
        .set(IS_FETCHING_SECTION_LIST, false)
        .set(HAS_FETCHED_SECTION_LIST, true);

    case actions.FETCH_ALL_SECTIONS:
      return state.set(IS_FETCHING_ALL_SECTIONS, true);

    case successAction(actions.FETCH_ALL_SECTIONS): {
      const { sections } = action.payload;
      return state
        .set(ALL_SECTIONS, fromJS(sections))
        .set(IS_FETCHING_ALL_SECTIONS, false);
    }

    case failureAction(actions.FETCH_ALL_SECTIONS):
      return state.set(IS_FETCHING_ALL_SECTIONS, false);

    case actions.SECTIONS_TAB_CHANGED:
      return state.set(SECTION_TAB_ID, action.payload);

    case actions.GROCERIES_TAB_CHANGED:
      return state.set(GROCERIES_TAB_KEY, action.payload);

    case actions.ONE_CLICK_PRODUCT_SELECTED:
      return state.set(ONE_CLICK_PRODUCT_SELECTED, action.payload);

    case actions.EXTENDED_MENU_SECTION_CHANGED:
      return state.set(EXTENDED_MENU_SECTION, action.payload);

    case actions.SECTION_HEIGHT_UPDATED: {
      const { index, height } = action.payload;
      return state.setIn([SECTIONS_HEIGHTS, index], height);
    }

    case successAction(actions.FETCH_DISTANCE_VENDOR_PICKUP): {
      return state.set(DISTANCE_VENDOR_PICKUP, action.payload);
    }

    case actions.FETCH_PREFERRED_DISHES:
      return state.set(IS_FETCHING_PREFERRED_DISHES, true);

    case successAction(actions.FETCH_PREFERRED_DISHES): {
      return state
        .set(PREFERRED_DISHES, action.payload)
        .set(IS_FETCHING_PREFERRED_DISHES, false);
    }

    case failureAction(actions.FETCH_PREFERRED_DISHES):
      return state.set(IS_FETCHING_PREFERRED_DISHES, false);

    default:
      return state;
  }
}

export default orderFlowReducer(shopDetailsModuleReducer, ModuleStateModel);
